var React = require('react');

function CheckMark2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Shape_2_kopia_21","d":"M830.5,161.7L365.4,786.2l0,0c-22.2,31.3-65.6,38.7-96.9,16.5c-6.4-4.5-12-10.1-16.5-16.5l0,0\n\tL19.3,473.9l0,0c-23-31.6-20.7-75,5.6-103.9l29-31.5c25.5-28.3,69.2-30.6,97.5-5.1c0.4,0.4,0.8,0.7,1.2,1.1l0,0l141.7,168.4\n\tL724.2,55.6l0,0c13-13.4,31-21,49.7-21.1c41.7,1.6,74.2,36.6,72.6,78.3c0,0.1,0,0.1,0,0.2C846.5,130.5,840.9,147.6,830.5,161.7\n\tL830.5,161.7z"}));
}

CheckMark2.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 850 850","style":{"enableBackground":"new 0 0 850 850"},"xmlSpace":"preserve"};

module.exports = CheckMark2;

CheckMark2.default = CheckMark2;
